import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const AmazonFlex = ({
  width = '50',
  height = '50'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <IconSvg
      style={{
        width: width,
        height: height
      }}
      fill="#00bf8f"
      fillRule="evenodd"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="220.000000pt"
      height="233.000000pt"
      viewBox="0 0 220.000000 233.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,233.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M454 2130 c-33 -13 -54 -50 -54 -94 0 -40 7 -47 345 -386 l345 -345
345 345 c341 341 345 346 345 386 0 72 -63 119 -132 99 -12 -4 -143 -127 -291
-273 l-267 -267 -273 273 c-254 253 -275 272 -307 271 -19 0 -45 -4 -56 -9z"
        />
        <path
          d="M128 1810 c-27 -28 -30 -36 -25 -77 5 -45 12 -53 271 -312 l266 -266
-264 -265 c-229 -229 -266 -270 -271 -303 -17 -91 64 -155 143 -113 15 8 176
164 357 345 l330 331 -345 345 -346 345 -43 0 c-34 0 -49 -6 -73 -30z"
        />
        <path
          d="M1588 1493 l-348 -348 327 -328 c181 -181 340 -335 355 -343 32 -17
81 -18 110 -3 28 15 51 74 43 113 -5 23 -72 96 -273 299 l-267 267 262 263
c143 144 266 272 272 284 20 39 13 73 -23 109 -27 27 -42 34 -72 34 -37 0 -51
-12 -386 -347z"
        />
        <path
          d="M743 658 c-370 -372 -373 -376 -336 -441 25 -42 64 -61 111 -52 31 6
77 46 302 271 146 145 267 264 270 264 2 0 126 -121 275 -270 255 -254 273
-270 307 -270 45 0 94 38 103 79 4 17 0 43 -8 62 -9 20 -154 173 -349 367
l-333 332 -342 -342z"
        />
      </g>
    </IconSvg>
  )
}

export default AmazonFlex
